import React from 'react';
import styled, { keyframes } from 'styled-components';

export const Loader = ({ size = 80, color = '#FFFFFF', margin = '0' }: LoaderProps) => {
	return (
		<LoaderWrapper size={size} margin={margin}>
			{[0, 1, 2, 3].map((i) => (
				<LoaderSpinner key={i} i={i} size={size} color={color} />
			))}
		</LoaderWrapper>
	);
};

export default Loader;

export interface LoaderProps {
	size?: number;
	color?: string;
	margin?: string;
}

const LoaderWrapper = styled.div<{ size: number; margin: string }>`
	display: inline-block;
	position: relative;
	width: ${({ size }) => size}px;
	height: ${({ size }) => size}px;
	margin: ${({ margin }) => margin};
`;

const spinningEffect = keyframes`
	0% { transform: rotate(0deg);}
	100% { transform: rotate(360deg);}
`;

const LoaderSpinner = styled.div<{ i: number; size: number; color: string }>`
	box-sizing: border-box;
	display: block;
	position: absolute;
	width: ${({ size }) => size}px;
	height: ${({ size }) => size}px;
	border: ${({ size }) => size * 0.08}px solid ${({ color }) => color};
	border-radius: 50%;
	animation: ${spinningEffect} 1.2s cubic-bezier(0.5, 0, 0.5, 1) infinite;
	border-color: ${({ color }) => color} transparent transparent transparent;
	animation-delay: ${({ i }) => i * -0.15}s;
`;
